import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import dentallyLogo from "../../../assets/dentally-logo.png";
import successCheck from "../../../assets/success-check.png";
import PasswordResetInjectors from "../ForgotPassword/injectors";
import { resetFlow } from "../ForgotPassword/slice";
import {
  CheckIcon,
  FormCard,
  ImageCard,
  LeftCol,
  LogoImage,
  PageRow,
  PrimaryButton,
  RightCol,
  StyledTitle,
  SubtitleText,
  SuccessBlock,
} from "./style";

export default function PasswordChangedPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  function handleProceed() {
    dispatch(resetFlow());
    navigate("/login");
  }

  return (
    <PageRow>
      <PasswordResetInjectors />
      <LeftCol xs={0} sm={0} md={0} lg={12} xl={12}>
        <ImageCard />
      </LeftCol>

      <RightCol xs={24} sm={24} md={24} lg={12} xl={12}>
        <FormCard vertical align="flex-start">
          <LogoImage
            src={dentallyLogo}
            alt="Dentally"
            width={233}
            preview={false}
          />

          <SuccessBlock vertical>
            <StyledTitle level={1}>Password Changed Successfully</StyledTitle>

            <SubtitleText>
              Your password has been updated successfully
            </SubtitleText>

            <CheckIcon
              src={successCheck}
              alt="Success"
              width={120}
              preview={false}
            />

            <PrimaryButton type="primary" block onClick={handleProceed}>
              Back to Log in
            </PrimaryButton>
          </SuccessBlock>
        </FormCard>
      </RightCol>
    </PageRow>
  );
}
